import {
  useGetVisaDocument,
  useUpdateVisaDocument,
} from 'api-hooks/visa-document';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useDismiss from 'hooks/use-dismiss';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import React from 'react';
import { NavigationProps } from 'types';

import VisaDocumentForm from './components/visa-document-form';

export type VisaDocumentViewProps = {
  id: string;
};

export default function VisaDocumentView(
  props: NavigationProps<NavigationRoutes.VisaDocumentView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetVisaDocument({
    id,
  });
  const { close, navigate } = useNavigation();
  const { mutateAsync, error: errorMutate } = useUpdateVisaDocument();

  const visaDocument = data?.data;
  const permission = useGetCrudPermission('visa-documents');
  const onDismiss = useDismiss('visa-documents', visaDocument?.id);

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <VisaDocumentForm
          {...props}
          renderError={
            !!errorMutate &&
            !!errorMutate.message && (
              <>
                <Notification
                  overrides={{
                    Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                  }}
                  kind={KIND.negative}
                  closeable
                >
                  {() => errorMutate.message}
                </Notification>
                <SeparatorVertical $margin={8} />
              </>
            )
          }
          visaDocument={visaDocument}
          onSubmit={async (input, form) => {
            const result = await mutateAsync({
              body: input,
              id: visaDocument!.id,
            });

            notification.success({ message: result.message });

            close();
            onDismiss(result.data.id);

            if (permission.view) {
              navigate(NavigationRoutes.VisaDocumentView, {
                id: result.data.id,
              });
            }

            return result.data;
          }}
        />
      }
    />
  );
}
